import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [token, setToken] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const response = await axios.post(
        "https://staging.drugstoc.com/api/v2/auth/password_reset/confirm/",
        {
          password,
          token,
        }
      );
      setMessage(
        `Password Reset Successfully. ${response.data.status.toUpperCase()}.`
      );
    } catch (err: any) {
      setError(err.message);
    }
  };
  const navigate = useNavigate();
  const onClick = () => {
    navigate("/login");
  };
  return (
    <div>
      <h1>Reset Password</h1>
      <form onSubmit={handleSubmit}>
        <label>
          Enter a new password::
          <div>
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
        </label>

        <label>
          Enter new generated Token:
          <div>
            <input
              type="text"
              value={token}
              onChange={(event) => setToken(event.target.value)}
            />
          </div>
        </label>

        <div>
          <button onClick={onClick} type="submit">
            Reset Password
          </button>
        </div>
      </form>
      {message && <p style={{ color: "green" }}>{message}</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default ResetPassword;
